import { render, staticRenderFns } from "./AlarmHeader.vue?vue&type=template&id=320fd620&scoped=true&"
import script from "./AlarmHeader.vue?vue&type=script&lang=js&"
export * from "./AlarmHeader.vue?vue&type=script&lang=js&"
import style0 from "./AlarmHeader.vue?vue&type=style&index=0&id=320fd620&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320fd620",
  null
  
)

export default component.exports